/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_Total_NetInputs */

const vi_einvoice_draft_total_net = /** @type {(inputs: Einvoice_Draft_Total_NetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền trước VAT`)
};

/**

* @param {Einvoice_Draft_Total_NetInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_total_net = /** @type {((inputs?: Einvoice_Draft_Total_NetInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_Total_NetInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_total_net(inputs)
});